import { parse } from 'date-fns';
/**
 * 기본 정렬
 */
export const basicSort = (a, b) => {
    if (a > b) {
        return 1;
    }
    if (a < b) {
        return -1;
    }
    return 0;
};
/**
 * 멀티 소트
 */
export const multiSort = (data, logic, sortBy) => {
    let array = data;
    if (!Array.isArray(array)) {
        array = Object.values(array);
    }
    array.sort((a, b) => {
        let result = 0;
        sortBy.some(({ key, order }) => {
            result = logic[key](a, b);
            if (order === 'desc') {
                result *= -1;
            }
            return result;
        });
        return result;
    });
    return array;
};
/**
 * 문자열 정렬
 * 가나다, 다나가
 */
export const sortLocale = (a, b) => a.localeCompare(b);
/**
 * 날짜 정렬
 */
export const sortDate = (dateFormat) => (a, b) => {
    const dateA = parse(a, dateFormat, new Date());
    const dateB = parse(b, dateFormat, new Date());
    return dateA - dateB;
};
/**
 * 숫자 정렬
 */
export const sortNumber = (a, b) => parseFloat(a) - parseFloat(b);
